import { useEffect, useState } from 'react'

const getViewHeight = (): number => {
  if (typeof document !== 'undefined') {
    return document.documentElement?.clientHeight || window.innerHeight
  }

  return 0
}

/**
 * Utility hook to provide actual values for viewport heights in iOS Safari and
 * Android Chrome. Due to a difference in spec interpretation, Safari and Chrome
 * Do not include browser UI elements (navigation bars, back/forward controls, etc)
 * when using VH. As such, `100vh` measurements will always be wrong when attempting
 * to create a full-screen experience.
 */
const useTrueVH = (): number => {
  const [height, setHeight] = useState(getViewHeight())
  const updateHeight = (): void => {
    setHeight(getViewHeight())
  }

  useEffect(() => {
    if (window) {
      window.addEventListener('resize', updateHeight)
    }

    return (): void => {
      if (window) {
        window.removeEventListener('resize', updateHeight)
      }
    }
  })

  return height
}

export default useTrueVH
